import React, { useState, useRef, useEffect } from 'react';
import { StoryDetails, UserModel } from '../core/_models';
// Define the type for images, including language, level, and age
// interface Image {
//   id: number;
//   src: string;
//   alt: string;
//   title: string;
//   language: string;
//   level: string;
//   age: string; // New property for age filter
//   text: string | null;
// }
import { useIntl } from 'react-intl'
import StarRatings from 'react-star-ratings';

interface ModalProps {
  isOpen: boolean;
  showPrintButton: boolean;
  onClose: () => void;
  onDelete?: () => void; // Νέο prop για διαγραφή
  onRate?: (rating: number) => void; // Νέο prop για rating
  allowRating: boolean; // Allow rating
  onShareableChange?: (newShareableStatus: boolean) => void; // Νέο prop για την αλλαγή δημόσιου καθεστώτος
  currentUser?: UserModel;
  // selectedStory: Image | null;
  storyDetails: StoryDetails;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, showPrintButton, onClose, onDelete, onRate, allowRating, onShareableChange, currentUser, storyDetails }) => {
  const intl = useIntl();
  const printRef = useRef<HTMLDivElement>(null); // Χρησιμοποιούμε ref για επιλεκτική εκτύπωση
  const [userRating, setUserRating] = useState(storyDetails.rate);
  const [isShareable, setIsShareable] = useState(storyDetails.shareable);

  useEffect(() => {
    setUserRating(storyDetails.rate);
    setIsShareable(storyDetails.shareable); // Αρχικοποίηση της κατάστασης για το shareable/ιδιωτικό
  }, [storyDetails]);
  
  if (!isOpen || !storyDetails) return null;

  const handleRatingChange = (newRating: number) => {
    setUserRating(newRating);
    if (onRate) {
      onRate(newRating); // Καλούμε τη συνάρτηση onRate αν υπάρχει
    }
  };

  const handlePrint = () => {
    if (printRef.current) {
      const printContent = printRef.current.innerHTML;
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
                  <html>
                      <head>
                          <title>Print Story Details</title>
                          <style>
                              body { font-family: Arial, sans-serif; margin: 20px; }
                              img { max-width: 100%; height: auto; }
                              .print-container { text-align: center; }
                          </style>
                      </head>
                      <body>
                          <div class="print-container">${printContent}</div>
                      </body>
                  </html>
              `);
        printWindow.document.close();
        printWindow.print();
      }
    }
  };

  const handleShareableChange = () => {
    if (onShareableChange) {
      // Καλούμε την onShareableChange συνάρτηση που περνάει ως prop
      onShareableChange(!isShareable); // Εναλλάσσουμε το δημόσιο καθεστώς
    }
  };

  const modalStyle: React.CSSProperties = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
    zIndex: 1000,
    width: '80%',
    maxWidth: '800px',
    maxHeight: '90%',
    overflowY: 'auto',
  };

  const headerStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
    textAlign: 'center',
    color: '#333',
  };

  const gridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)', // 1 στήλες
    gap: '20px',
    marginTop: '20px',
  };

  const itemStyle: React.CSSProperties = {
    textAlign: 'center',
  };

  const imageStyle: React.CSSProperties = {
    width: '50%',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    marginBottom: '10px',
  };

  const textStyle: React.CSSProperties = {
    fontSize: '18px',
    color: '#555',
  };

  const footerStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr', // Τρεις ίσες στήλες
    gap: '10px',
    marginTop: '20px',
    alignItems: 'center',
  };

  const leftColumnStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-start',
  };

  const centerColumnStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
  };

  const rightColumnStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-end',
  };

  // Δημιουργούμε έναν πίνακα με εικόνες και τα αντίστοιχα κείμενα
  const imagesWithTexts: ({ src: string | null; id: number; text: string | null } | { src: string | null; id: number; text: string | null } | { src: string | null; id: number; text: string | null } | { src: string | null; id: number; text: string | null } | { src: string | null; id: number; text: string | null } | { src: string | null; id: number; text: string | null } | { src: string | null; id: number; text: string | null })[] = [
    { id: 1, src: storyDetails.image1, text: storyDetails.text1 },
    { id: 2, src: storyDetails.image2, text: storyDetails.text2 },
    { id: 3, src: storyDetails.image3, text: storyDetails.text3 },
    { id: 4, src: storyDetails.image4, text: storyDetails.text4 },
    { id: 5, src: storyDetails.image5, text: storyDetails.text5 },
    { id: 6, src: storyDetails.image6, text: storyDetails.text6 },
    { id: 7, src: storyDetails.image7, text: storyDetails.text7 },
  ].filter((item) => item.src); // Φιλτράρουμε τις εικόνες που είναι null

  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)', // ημιδιαφανές μαύρο
    backdropFilter: 'blur(5px)', // το blur
    zIndex: 999, // κάτω από το modal
  };

  return (
    <>
      {isOpen && (
        <div style={overlayStyle} onClick={onClose}></div>
      )}
      {isOpen && (
        <div style={modalStyle}>
          <div ref={printRef}>
            <h2 style={headerStyle}>{storyDetails.title}</h2>
            <p><strong>{intl.formatMessage({ id: 'Author' })}:</strong> {storyDetails.authorName}</p>
            <p><strong>{intl.formatMessage({ id: 'Synopsis' })}:</strong> {storyDetails.synopsis}</p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div className="form-check mt-6 mb-6 fs-2">
                <input
                  id="shareable"
                  type="checkbox"
                  className="form-check-input"
                  checked={isShareable}
                  readOnly={!onShareableChange || !currentUser?.roles?.includes('therapist')}
                  onChange={
                    onShareableChange && currentUser?.roles?.includes('therapist')
                      ? handleShareableChange
                      : undefined
                  }
                />
                <label htmlFor="shareable" className="form-check-label">
                  {intl.formatMessage({ id: 'MakePublic' })}
                </label>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <strong>{intl.formatMessage({ id: 'Rate' })}:</strong>
              <StarRatings
                rating={userRating}
                starRatedColor="gold"
                numberOfStars={5}
                name="rating"
                starDimension="20px"
                starSpacing="2px"
                changeRating={onRate ? ((currentUser?.roles?.includes('therapist') && allowRating) ? handleRatingChange : undefined) : undefined}
              />
            </div>
            <div style={gridStyle}>
              {imagesWithTexts.map((item) => (
                <div key={item.id} style={itemStyle}>
                  <img src={item.src || ''} alt={`Story ${item.id}`} style={imageStyle} />
                  {item.text && <p style={textStyle}>{item.text}</p>}
                </div>
              ))}
            </div>
            <div style={footerStyle}>
              {/* Αριστερή στήλη - Close Button */}
              <div style={leftColumnStyle}>
                <button onClick={onClose} className="btn btn-secondary">
                  {intl.formatMessage({ id: 'Close' })}
                </button>
              </div>
              
              {/* Κεντρική στήλη - Print Button */}
              <div style={centerColumnStyle}>
                {showPrintButton && (
                  <button onClick={handlePrint} className="btn btn-success">
                    {intl.formatMessage({ id: 'Print' })}
                  </button>
                )}
              </div>
              
              {/* Δεξιά στήλη - Delete Button */}
              <div style={rightColumnStyle}>
                {/* Προσθήκη του Delete αν ο χρήστης είναι ο συγγραφέας χωρίς να είναι δημόσια η ιστορία του ή εάν είναι διαχειριστής*/}
                {(currentUser?.roles?.includes('admin') || 
                  (currentUser?.name === storyDetails.authorName && !isShareable)) && 
                  onDelete && (
                    <button onClick={onDelete} className="btn btn-danger">
                      {intl.formatMessage({ id: 'DeleteStory' })}
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};